/**
 * Énumérations et constantes du domaine Playtime.
 *
 * Source de vérité : docs/cahier-des-charges/playtime-v2_cahier-des-charges-fonctionnel.md
 * Les identifiants numériques sont conservés tels quels (exigence §3 — reprise de données).
 */
/** §3.1 — Régimes de travail (`Regimes`). Identifiants v1 conservés. */
export const IdRegime = {
    PersonneDeConfiance: 0,
    HorairePrincipalFixe: 1,
    HoraireVariable: 2,
    HoraireFlottant: 3,
    PetiteFlexibilite: 4,
    NrtGrandeFlexAnnuelle: 5,
    NrtGrandeFlexTrimestrielle: 6,
    HoraireFixeImposeSousQuatreCinquiemes: 7,
    CreditTempsHoraireFlottant: 8,
};
export function familleRegime(idRegime) {
    return {
        estFixe: idRegime === 1 || idRegime === 2 || idRegime === 7,
        estFlottant: idRegime === 3 || idRegime === 8,
        estPetiteFlex: idRegime === 4,
        estNrt: idRegime === 5 || idRegime === 6,
        estPersonneDeConfiance: idRegime === 0,
    };
}
/**
 * RG-REC-005 — groupe sans récupération de demi-journée :
 * régimes {0, 2, 3, 8} (personnes de confiance, variables, flottants).
 */
export function estRegimeSansDemiRecup(idRegime) {
    return idRegime === 0 || idRegime === 2 || idRegime === 3 || idRegime === 8;
}
/** §3.3 — Types d'événements (planning ET prestation). */
export const TypeEvenement = {
    Travail: 1,
    Conge: 2,
    Maladie: 3,
    PetitChomage: 4,
    CongeSansSolde: 5,
    ReposCompensatoire: 6,
    ChomageTemporaire: 7,
};
/** §3.4 — Statuts mensuels (planning et prestations). */
export const StatutMensuel = {
    /** NULL/0 — « Manquant : à encoder ». */
    NonCommence: 0,
    EncodageEnCours: 1,
    EnAttenteDeValidation: 2,
    ValideEtFige: 3,
};
/** §3.6 — Droits applicatifs (`Utilisateurs.DroitsUtilisateur`). */
export const Droits = {
    Travailleur: 0,
    ChefDeService: 1,
    LecteurGlobal: 2,
    Administrateur: 9,
};
/** §3.7 — Valeurs spéciales du « Qui Fait Quoi ». */
export const Qfq = {
    /** Aucun enregistrement actif → fonctions bloquées, libellé « Inconnu ». */
    NonDefini: 999999,
    /** Sans objet (pas d'encodage / de validation / de commentateur). */
    SansObjet: -2,
    /** Encodeur planning : importé depuis FileMaker. */
    ImporteFilemaker: -1,
    /** Encodeur planning : encodé par le travailleur lui-même. */
    Travailleur: 0,
    // > 0 : id de la personne désignée
};
/**
 * §11.7 — Codes v2 des types de droits à repos (table `Repos`).
 * Le libellé v1 exact est conservé pour le golden master et la migration (mapping 1-1).
 */
export const TypeRepos = {
    RCS62: 'RCS62',
    RCS53: 'RCS53',
    RCS45: 'RCS45',
    RCF: 'RCF',
    INACT15: 'INACT15',
    INACT10: 'INACT10',
    RCCTE: 'RCCTE',
};
/** Libellés v1 exacts (clés fonctionnelles historiques — §11.7). */
export const LibelleReposV1 = {
    RCS62: 'RCS (Repos compensatoire supplémentaire) suite à plus de 62 heures prestées',
    RCS53: 'RCS (Repos compensatoire supplémentaire) suite à plus de 53 heures prestées',
    RCS45: 'RCS (Repos compensatoire supplémentaire) suite à plus de 45 heures prestées',
    RCF: 'Repos compensatoire dans les 6 semaines qui suivent un jour férié presté',
    INACT15: 'Inactivité garantie dans les 15 jours qui suivent un dimanche presté (hors dimanche)',
    INACT10: 'Inactivité obligatoire après 10 jours de travail continu',
    RCCTE: "RCCTE (Repos compensatoire accordé par convention d'entreprise) suite à solde de jours pris/jours dus",
};
const h = (heures, minutes = 0) => heures * 60 + minutes;
const quarts = (de, a) => { const r = []; for (let m = de; m <= a; m += 15)
    r.push(m); return r; };
export const GRILLES_FLOTTANTES_TN = [
    { id: 1, libelle: 'Grille 1', exemple: 'Exemple : pers. admin. en journée',
        plagesFixes: [{ libelle: 'Plage fixe 1', debut: h(10), fin: h(12) }, { libelle: 'Plage fixe 2', debut: h(14), fin: h(16) }],
        debut: { min: h(5, 30), max: h(10) }, fin: { min: h(16), max: h(20, 30) },
        pauseMidi: { debuts: quarts(h(12), h(13)), durees: [60, 90, 120] }, pauseSoir: { debuts: quarts(h(18), h(20, 30)) },
        am: { debut: h(9), fin: h(13) }, pm: { debut: h(14), fin: h(17, 30) } },
    { id: 2, libelle: 'Grille 2', exemple: 'Exemple : pers. admin. en matinée',
        plagesFixes: [{ libelle: 'Plage fixe 1', debut: h(9), fin: h(13) }],
        debut: { min: h(7), max: h(9) }, fin: { min: h(13), max: h(19) },
        pauseMidi: { debuts: [h(13)], durees: [60] }, pauseSoir: { debuts: [h(18), h(18, 15)] },
        am: { debut: h(9), fin: h(13) }, pm: { debut: h(14), fin: h(17, 30) } },
    { id: 3, libelle: 'Grille 3', exemple: "Exemple : pers. admin. l'après-midi",
        plagesFixes: [{ libelle: 'Plage fixe 1', debut: h(13, 30), fin: h(17, 30) }],
        debut: { min: h(8), max: h(13, 30) }, fin: { min: h(17, 30), max: h(23) },
        pauseMidi: { debuts: quarts(h(12), h(12, 30)), durees: [60, 90] }, pauseSoir: { debuts: quarts(h(18), h(20, 30)) },
        am: { debut: h(13, 30), fin: h(17, 30) }, pm: { debut: h(18, 30), fin: h(22) } },
    { id: 4, libelle: 'Grille 4', exemple: 'Exemple : pers. admin. avec permanence en soirée',
        plagesFixes: [{ libelle: 'Plage fixe 1', debut: h(16), fin: h(18) }, { libelle: 'Plage fixe 2', debut: h(19), fin: h(21) }],
        debut: { min: h(10, 30), max: h(16) }, fin: { min: h(21), max: h(26) },
        pauseMidi: { debuts: quarts(h(12), h(13)), durees: [60, 90, 120] }, pauseSoir: { debuts: quarts(h(18), h(18, 30)) },
        am: { debut: h(14), fin: h(18) }, pm: { debut: h(19), fin: h(22, 30) } },
    { id: 5, libelle: 'Grille 5', exemple: 'Exemple : pers. admin. avec permanence en soirée',
        plagesFixes: [{ libelle: 'Plage fixe 1', debut: h(19), fin: h(23) }],
        debut: { min: h(13, 30), max: h(19) }, fin: { min: h(23), max: h(28) },
        pauseSoir: { debuts: quarts(h(18), h(18, 30)) },
        am: { debut: h(19), fin: h(23) }, pm: { debut: h(24), fin: h(27, 30) } },
    { id: 6, libelle: 'Grille 6', exemple: "Exemple : personnel d'entretien",
        plagesFixes: [{ libelle: 'Plage fixe 1', debut: h(7), fin: h(9) }, { libelle: 'Plage fixe 2', debut: h(10), fin: h(12) }],
        debut: { min: h(5), max: h(7) }, fin: { min: h(12), max: h(17) },
        am: { debut: h(5), fin: h(9) }, pm: { debut: h(10), fin: h(13, 30) } },
];
/** §3.9 — Groupes de fonctions CCT 304 (0-6). */
export const GROUPES_FONCTIONS_TN = [
    { id: 0, libelle: 'Personnel de confiance' },
    { id: 1, libelle: 'Artistes de spectacle' },
    {
        id: 2,
        libelle: 'Assistant·e·s de direction artistique / technicien·ne·s avec responsabilité finale',
    },
    { id: 3, libelle: 'Administratif·ve·s et technicien·ne·s avec responsabilité non finale' },
    {
        id: 4,
        libelle: 'Administratif·ve·s d’exécution / collaborateur·rice·s spécialisé·e·s des ateliers',
    },
    { id: 5, libelle: 'Personnel logistique' },
    { id: 6, libelle: 'Figurant·e·s et personnel d’accueil' },
];
//# sourceMappingURL=enums.js.map